import { action, observable } from "mobx"
import * as StringsApi from "../Strings";
import * as Utilites from "../Utilities";
import { Promise } from 'es6-promise';
import { LanguageInfo } from "../Shared";

class StringsStoreImpl {
	@observable homepage: StringsApi.HomepageStrings;
	@observable language: LanguageInfo;
	@observable general: StringsApi.GeneralStrings;
	@observable appNavigation: StringsApi.AppNavigationStrings;
	@observable settings: StringsApi.SettingsStrings;
	@observable sync: StringsApi.SyncStrings;
	@observable reader: StringsApi.ReaderStrings;
	@observable userManagement: StringsApi.UserManagementStrings;
	@observable documentManagement: StringsApi.DocumentManagementStrings;
	@observable metaManagement: StringsApi.MetaManagementStrings;
	@observable globalSettings: StringsApi.GlobalSettingsStrings;
	@observable favorites: StringsApi.FavoritesStrings;
	@observable recentFiles: StringsApi.RecentFilesStrings;
	@observable datePicker: StringsApi.DatePickerStrings;

	@action
	load(lang: string): Promise<void> {
		Utilites.setCookie(".AspNetCore.Culture", `c=${lang}|uic=${lang}`, 3650);
		return StringsApi.getStringsAsync(lang).then((result) => {
			this.homepage = result.homepage;
			this.language = result.language;
			this.general = result.general;
			this.appNavigation = result.appNavigation;
			this.settings = result.settings;
			this.sync = result.sync;
			this.reader = result.reader;
			this.userManagement = result.userManagement;
			this.documentManagement = result.documentManagement
			this.metaManagement = result.metaManagement;
			this.globalSettings = result.globalSettings;
			this.favorites = result.favorites;
			this.recentFiles = result.recentFiles;
			this.datePicker = result.datePicker;
		});

	}
}

export var Strings: StringsStoreImpl = new StringsStoreImpl();
